/*
 * Zazu application code
 * @author Sebastian Helzle <sebastian@helzle.net>
 */
/*global define, window, document, console, JSON*/

import $ from 'jquery';
import Typed from 'typed.js';
import './Libs/jquery.sortElements';
import Swiper from 'swiper/swiper-bundle.mjs';

window.jQuery = $;
window.$ = $;

require('bootstrap-sass/assets/javascripts/bootstrap/transition.js');
require('bootstrap-sass/assets/javascripts/bootstrap/dropdown.js');
require('bootstrap-sass/assets/javascripts/bootstrap/collapse.js');
require('bootstrap-sass/assets/javascripts/bootstrap/carousel.js');
require('bootstrap-sass/assets/javascripts/bootstrap/tooltip.js');
require('magnific-popup');

jQuery(function ($) {
    const $window = $(window);
    const $document = $(document);
    const location = window.location;
    const inNeosBackend = $('body').hasClass('neos-backend');

    // Disable collapse transition to prevent delay in table collapse animation
    $.fn.collapse.Constructor.TRANSITION_DURATION = 0;

    // Define library defaults
    const swiperDefaultOptions = {
        loop: !inNeosBackend,
        //autoplay: !inNeosBackend,
        centeredSlides: true,
        grabCursor: !inNeosBackend,
        allowTouchMove: !inNeosBackend,
        watchOverflow: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            dynamicBullets: true,
            dynamicMainBullets: 2,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        keyboard: {
            enabled: !inNeosBackend,
            onlyInViewport: true,
        },
    };
    const carousels = [];

    /*
     * Smooth scroll for in page links
     */
    function initSmoothScrolling() {
        let target;
        let scroll;
        const $htmlBody = $('html, body');
        const $html = $('html');

        $("a[href*='#']:not([href='#']):not([role='button'])").on('click', (e) => {
            const { pathname, hash, hostname } = e.currentTarget;
            if (
                location.pathname.replace(/^\//, '') === pathname.replace(/^\//, '') &&
                location.hostname === hostname
            ) {
                target = $(hash);
                if (!target.length) {
                    target = $('[id=' + hash.slice(1) + ']');
                }

                if (target.length) {
                    e.preventDefault();

                    const avail = $document.height() - $window.height();
                    scroll = Math.min(target.offset().top, avail);

                    $html
                        .css({
                            'margin-top': $window.scrollTop() - scroll + 'px',
                            transition: '0.3s ease-in-out',
                        })
                        .data('transitioning', true);
                }
            }
        });

        $html.on('transitionend webkitTransitionEnd msTransitionEnd oTransitionEnd', (e) => {
            const $self = $(e.currentTarget);
            if (e.target === e.currentTarget && $self.data('transitioning') === true) {
                $self.removeAttr('style').data('transitioning', false);
                $htmlBody.scrollTop(scroll);
            }
        });
    }

    /*
     * Radio buttons should change their containers class to allow further styling
     */
    function initRadioButtonClassChanger() {
        $('form').on('change', 'input[type=radio]', (e) => {
            $(e.currentTarget).closest('.radio').addClass('checked').siblings('.radio').removeClass('checked');
        });
    }

    function initSwiping() {
        document.querySelectorAll('[data-component="carousel"]').forEach((component) => {
            let options = { ...swiperDefaultOptions, ...JSON.parse(component.dataset.options) };
            const canSlide = component.querySelectorAll('.swiper-slide').length > 1;
            options.loop = options.loop && canSlide;
            options.pagination = canSlide ? options.pagination : false;
            options.allowTouchMove = canSlide ? options.allowTouchMove : false;
            options.grabCursor = canSlide ? options.grabCursor : false;

            if (!!options.thumbs) {
                const thumbnailsComponent = component.nextSibling;
                if (thumbnailsComponent) {
                    const thumbnailOptions = JSON.parse(thumbnailsComponent.dataset.options);
                    options.thumbs.swiper = new Swiper(thumbnailsComponent, thumbnailOptions);
                } else {
                    options.thumbs = {};
                }
            }

            // new LuminousGallery(component.querySelectorAll('img'), {}, {
            //     sourceAttribute: 'data-lightbox-src',
            //     showCloseButton: true,
            //     injectBaseStyles: false,
            //     caption: (elem) => elem.getAttribute('title'),
            // });

            carousels.push(new Swiper(component, options));
        });
    }

    function reloadChangedCarousels(changedElement) {
        carousels.forEach((carousel) => {
            if (carousel.el.contains(changedElement)) {
                carousel.update();
            }
        });
    }

    function updateAffectedCarousels(selectedElement) {
        if (!selectedElement.classList.contains('swiper-slide')) {
            return;
        }
        carousels.forEach((carousel) => {
            if (carousel.el.contains(selectedElement)) {
                const siblings = [].slice.call(selectedElement.parentElement.childNodes);
                carousel.slideTo(siblings.indexOf(selectedElement), 0);
            }
        });
    }

    function initPopups() {
        $('[data-mfp-src]').magnificPopup({
            type: 'inline',
            mainClass: 'mfp-fade',
            callbacks: {
                elementParse: (item) => {
                    let replacements = item.el[0].dataset.popupReplacements;
                    if (replacements) {
                        replacements = JSON.parse(replacements);
                        Object.keys(replacements).forEach((key) => {
                            $(item.src)
                                .find('#' + key)
                                .attr('value', replacements[key]);
                        });
                    }
                },
            },
        });
    }

    function initTypedHeadlines() {
        document.querySelectorAll('[data-component="typed"]').forEach((element) => {
            let firstTitle = element.innerText;

            let wrapper = document.createElement('span');
            wrapper.innerText = firstTitle;
            element.innerHTML = '';
            element.appendChild(wrapper);

            const additionalTitles = JSON.parse(element.dataset.additionalTitles);
            const loop = element.dataset.loop !== undefined;

            // @ts-ignore
            let typed = new Typed(wrapper, {
                strings: additionalTitles,
                typeSpeed: 60,
                backSpeed: 30,
                startDelay: 2000,
                backDelay: 1000,
                smartBackspace: true,
                loop,
                autoInsertCss: true,
            });
        });
    }

    function initSortableTables() {
        $('table[data-sortable]').each((table) => {
            const $table = $(table);
            const $headers = $table.find('th');

            $headers.each((header) => {
                const $th = $(header);
                const thIndex = $th.index();
                let inverse = thIndex === 0;

                $th.find('svg.fa-caret-down').hide();

                $th.click((e) => {
                    const $self = e.currentTarget;
                    $table
                        .find('td')
                        .filter(() => $self.index() === thIndex)
                        .sortElements(
                            (a, b) => {
                                const aText = $(a).data('value');
                                const bText = $(b).data('value');

                                if (aText === bText) {
                                    return 0;
                                }
                                return aText > bText ? (inverse ? -1 : 1) : inverse ? 1 : -1;
                            },
                            () => {
                                // parentNode is the element we want to move
                                return $self[0].parentNode;
                            }
                        );

                    inverse = !inverse;

                    $self.find('svg.fa-caret-' + (inverse ? 'up' : 'down')).show();
                    $self.find('svg.fa-caret-' + (inverse ? 'down' : 'up')).hide();
                });
            });
        });
    }

    function sendFormData(form, callback) {
        const xhr = new XMLHttpRequest();
        const formAjaxUrl = location.protocol + '//' + location.host + '/form/' + form.id;
        const formData = new FormData(form);
        const submitButton = form.querySelector('button');
        formData.append(submitButton.name, submitButton.value); // Value of submit button is not added by default to formdata

        xhr.addEventListener('load', (event) => {
            callback(event.target.responseText);
        });
        xhr.addEventListener('error', () => {
            callback(null);
        });

        xhr.open('POST', formAjaxUrl);
        xhr.send(formData);
        form.innerHTML =
            '<div class="spinner-wrap"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner" class="svg-inline--fa fa-spinner fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path></svg></div>';
    }

    function initAjaxForms() {
        const ajaxForms = document.querySelectorAll('[data-ajaxform] form');
        ajaxForms.forEach((form) => {
            form.onsubmit = (e) => {
                e.preventDefault();
                form.querySelector('button').setAttribute('disabled', 'disabled');
                sendFormData(form, (result) => {
                    if (result) {
                        const el = document.createElement('html');
                        el.innerHTML = result;
                        form.outerHTML = el.querySelector('.ajax-content').innerHTML;
                        initAjaxForms();
                    } else {
                        form.innerHTML =
                            '<div class="error-wrap">Error submitting the form. Please reload the page and try again.</div>';
                    }
                });
            };
        });
    }

    function initTooltips() {
        $('[data-toggle="tooltip"]').tooltip({
            placement: 'auto bottom', // Prefer bottom placement
            trigger: 'hover focus click',
            container: 'body',
        });
    }

    function initQuickNav() {
        const $quickNavContainer = document.querySelector('.quick-nav');
        const $quickNavInput = document.getElementById('quick-nav-input');
        const $quickNavPopover = document.getElementById('quick-nav-results');

        if (!$quickNavInput || !$quickNavPopover) {
            return;
        }

        const $quickNavResults = $quickNavPopover.querySelector('nav');

        if (!$quickNavResults) {
            return;
        }

        if (!HTMLElement.prototype.hasOwnProperty('popover')) {
            $quickNavContainer.classList.add('unsupported');
            return;
        }

        const quickNavUrl = new URL($quickNavInput.dataset.url);
        const debounceTime = $quickNavInput.dataset.debounceTime || 500;
        let timeout = null;

        function fetchResults() {
            fetch(quickNavUrl)
                .then((data) => data.json())
                .then(
                    /** @param {Array<{title: string, url: string}>} data */ (data) => {
                        $quickNavResults.innerHTML = '';

                        data.forEach((result) => {
                            const $result = document.createElement('a');
                            $result.href = result.url;
                            $result.innerText = result.title;
                            $quickNavResults.appendChild($result);
                        });
                    }
                )
                .catch((error) => {
                    console.error(error);
                });
        }

        $quickNavInput.addEventListener('input', (e) => {
            quickNavUrl.searchParams.set('term', e.target.value);

            // Clear timeout if it exists to prevent multiple requests
            if (timeout) {
                clearTimeout(timeout);
            }

            // Load new results after a timeout
            timeout = setTimeout(fetchResults, debounceTime);
        });
    }

    if (
        'IntersectionObserver' in window &&
        'IntersectionObserverEntry' in window &&
        'intersectionRatio' in window.IntersectionObserverEntry.prototype
    ) {
        let observer = new IntersectionObserver((entries) => {
            if (entries[0].boundingClientRect.y < 0) {
                document.body.classList.add('header-not-at-top');
            } else {
                document.body.classList.remove('header-not-at-top');
            }
        });
        const anchor = document.querySelector('#top-of-site-pixel-anchor');
        if (anchor) {
            observer.observe(anchor);
        }
    }

    function fixPreview(img) {
        let src = img.getAttribute('src');
        if (img.naturalHeight <= 90 && img.naturalWidth <= 120 && src.indexOf('/default.jpg') == -1) {
            src = src
                .replace('mqdefault', 'default')
                .replace('hqdefault', 'mqdefault')
                .replace('sddefault', 'hqdefault')
                .replace('maxresdefault', 'sddefault');
            img.setAttribute('src', src);
            setTimeout(() => {
                img.onload = () => {
                    fixPreview(img);
                };
            }, 10);
            setTimeout(() => {
                fixPreview(img);
            }, 5000);
        }
    }

    function fixPreviews(images) {
        if (typeof images === 'undefined') {
            images = document.querySelectorAll('img.jonnitto-prettyembed__youtube-preview');
        }
        for (let i = images.length - 1; i >= 0; i--) {
            fixPreview(images[i]);
        }
    }

    // Initialize all features
    initSmoothScrolling();
    initRadioButtonClassChanger();
    initPopups();
    initTypedHeadlines();
    initSortableTables();
    initAjaxForms();
    initSwiping();
    initTooltips();
    initQuickNav();
    fixPreviews();

    if (inNeosBackend) {
        document.addEventListener(
            'Neos.PageLoaded',
            () => {
                initPopups();
                fixPreviews();
            },
            false
        );

        // Setup backend event listeners
        document.addEventListener(
            'Neos.NodeCreated',
            (event) => {
                reloadChangedCarousels(event.detail.element);
                initSwiping();
                fixPreviews();
            },
            false
        );

        document.addEventListener(
            'Neos.NodeRemoved',
            (event) => {
                reloadChangedCarousels(event.detail.element);
            },
            false
        );

        document.addEventListener(
            'Neos.NodeSelected',
            (event) => {
                updateAffectedCarousels(event.detail.element);
            },
            false
        );
    }
});
